import { HorizontalBarChartComponent } from '../charts/horizontal-bar-chart-component'

export class AFTwitterAuthorAuthority extends HorizontalBarChartComponent {
 static config = {
  selector: 'afTwitterAuthorAuthority',
  controller: AFTwitterAuthorAuthority,
  bindings: HorizontalBarChartComponent.config.bindings,
  template: HorizontalBarChartComponent.config.template,
 }

 setProperties() {
  this.colorPalette = ['#1DD1A1']
  this.csvHeaders = ['Category', 'Count']
 }

 onPointClick = () => {}
}
